import SearchField from './search-field.vue';

export default SearchField;
